module.exports = __webpack_public_path__ + "static/img/step4.3d9b15b8.png";